








































































import Vue from 'vue';

export default Vue.extend({
  name: 'Girl',
  props: {
    isSelected: Boolean,
  },
});
